import React, { FC } from 'react';
import { Link } from '@/navigation';
import { TypeImage } from '@/core/generated-types';
import { Image } from '@/components/ui/Image';

interface SimpleNavProps {
  logo: TypeImage;
}

const SimpleNav: FC<SimpleNavProps> = ({ logo }) => {
  return (
    <nav className="z-50 bg-white">
      <div className="items-center pt-5 pb-3 lg:px-8 xl:px-12">
        <div className="flex justify-center py-4">
          <Link href={'/'}>
            <figure>
              {logo && (
                <Image
                  imageData={logo}
                  width={167}
                  height={18}
                  alt="Lovevery Logo"
                />
              )}
            </figure>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default SimpleNav;
